import React from "react";
import "./allocation.scss";

import allocationImg from "../../assets/imgs/allocation.png";

const Allocation = () => {
    return (
        <section className="container bgSecond allocation ">
            <div className="grid wide">
                <div className="allocation__content">
                    <h3 className="textBox__title">DOSE Token Allocation</h3>
                    <p className="textBox__text">
                        The total supply of DOSE has been fixed at 5,000,000,000
                        tokens.
                    </p>

                    <img src={allocationImg} alt="allocation" />
                </div>
            </div>
        </section>
    );
};

export default Allocation;
